"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _bluebird = _interopRequireDefault(require("bluebird"));
var _lodash = _interopRequireDefault(require("lodash"));
var _uuid = require("uuid");
var _basic_data_hub_api = _interopRequireDefault(require("./basic_data_hub_api"));
var _constants = require("./lib/constants");
var _utils = require("./lib/utils");
var _tags = _interopRequireDefault(require("./tags"));
const defaultLambdaMemorySize = 1024;
const defaultLambdaTimeout = 30;
class FlowsApi extends _basic_data_hub_api.default {
  /**
   * @constructor
   */
  constructor(_ref) {
    let {
      dataHubUrl,
      userTokenFactory,
      onGraphQLErrors,
      onNetworkError,
      deployerUrl,
      sdkApiUrl,
      accountId,
      defaultLimit,
      accountIdFactory,
      feature
    } = _ref;
    super({
      dataHubUrl,
      userTokenFactory,
      onGraphQLErrors,
      onNetworkError,
      accountId,
      defaultLimit,
      accountIdFactory,
      feature
    });
    this.sdkApiUrl = sdkApiUrl;
    this.deployerUrl = deployerUrl;
  }
  get deployUrl() {
    return this.accountId ? `${this.deployerUrl}/accounts/${this.accountId}/flows/deploy` : `${this.deployerUrl}/flows/deploy`;
  }
  get checkUrl() {
    return this.accountId ? `${this.deployerUrl}/accounts/${this.accountId}/flows/check` : `${this.deployerUrl}/flows/check`;
  }
  async activateFlow(flow, progressCallback, pollinOptions) {
    const flowAlias = `v-${Date.now()}`;
    const headers = await this.getHeaders();
    const {
      data: {
        requestId
      }
    } = await _axios.default.post(this.deployUrl, {
      flowId: flow.id,
      flowAlias,
      interactiveDebug: flow.interactiveDebug,
      role: _lodash.default.get(flow, 'data.deploy.role')
    }, headers);
    return this._pollResult(flow.id, requestId, headers, progressCallback, pollinOptions);
  }
  async deactivateFlow(flow, flowAlias) {
    let deleteLambda = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    let pollinOptions = arguments.length > 3 ? arguments[3] : undefined;
    const headers = await this.getHeaders();
    const requestParams = _lodash.default.merge({
      data: {
        flow: {
          id: flow.id
        },
        flowAlias,
        role: _lodash.default.get(flow, 'data.deploy.role'),
        deleteLambda
      },
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }, headers);
    const {
      data: {
        requestId
      }
    } = await _axios.default.delete(this.deployUrl, requestParams);
    return this._pollResult(flow.id, requestId, headers, undefined, pollinOptions);
  }
  async deleteFlow(flow) {
    let flowAlias = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'dev';
    let temporarily = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    return this._callApi({
      path: `/flows/${flow.id}`,
      payload: {
        flowAlias,
        temporarily
      },
      method: 'delete',
      queryParams: {}
    });
  }
  async recoverFlow(flow) {
    return this._callApi({
      path: `/flows/${flow.id}`,
      method: 'patch',
      queryParams: {}
    });
  }

  // lockFlow ({id, force}) {
  //     return Promise.try(() => Vue.http.get(`${this.flowsLockUrl}/${id}`, _.merge({params : {force}}, this.headers)))
  //         .then(response => response.json());
  // }

  async getFlowById(id, projection) {
    let sandbox = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return this._callApi({
      path: `/flows/${id}`,
      queryParams: {
        projection,
        sandbox
      }
    });
  }
  async getFlows(_ref2) {
    let {
      query = {},
      stepsQuery,
      onlyWithSteps,
      projection,
      includeDeleted = false,
      includeExisting = true,
      sandbox = false,
      limit,
      offset,
      group
    } = _ref2;
    if (_lodash.default.isString(query.id)) query.id = query.id.split(',');
    if (includeDeleted && !includeExisting) query.isDeleted = true;
    if (!includeDeleted && includeExisting) query.isDeleted = false;
    return this._callApi({
      path: `/flows`,
      queryParams: {
        projection,
        query,
        sandbox,
        limit,
        offset,
        group,
        stepsQuery,
        onlyWithSteps
      }
    });
  }
  async getFlowsByToken(_ref3) {
    let {
      query = {},
      projection,
      limit,
      token
    } = _ref3;
    const binding = await this.getBinding();
    const method = this._getMethodName('list');
    const accountId = this.accountId;
    return binding.query[method]({
      entity: _constants.FLOW,
      params: {
        ids: query.id ? _lodash.default.split(query.id, ',') : undefined,
        queryParams: query,
        limit,
        last: token
      },
      ...(accountId ? {
        accountId
      } : {})
    }, projection || ['records', 'last']);
  }
  async getFlowsWithTags(_ref4) {
    let {
      query = {},
      projection
    } = _ref4;
    const flows = this.getFlows({
      query,
      projection
    });
    const tagsApi = new _tags.default(this);
    return tagsApi.getEntitiesWithTags(flows);
  }
  async listFlowsByStepTemplate(_ref5) {
    let {
      query = {},
      stepTemplateId,
      projection,
      includesStep = false
    } = _ref5;
    if (_lodash.default.isString(query.id)) query.id = query.id.split(',');
    if (stepTemplateId) query.id = stepTemplateId;
    return this._callApi({
      path: `/flows/by-step-template`,
      queryParams: {
        projection,
        query,
        includesStep
      }
    });
  }
  getFlowsByBotId(botId, projection) {
    return this.getFlows({
      query: {
        botId
      },
      projection
    });
  }
  getFlowsWithTagsByBotId(botId, projection) {
    return this.getFlowsWithTags({
      query: {
        botId
      },
      projection
    });
  }
  async getFlowEvents(_ref6) {
    let {
      flowId,
      alias = 'prod'
    } = _ref6;
    const headers = await this.getHeaders();
    return _bluebird.default.try(() => _axios.default.get(`${this.sdkApiUrl}/event-manager/get-flow-events/${flowId}/${alias}`, headers)).then(response => _bluebird.default.resolve(response.data));
  }

  /**
      * function that gets list of flows that subscribed on certain triggers
      * @param {Array} triggers   list of triggers the active flows should be returned for
      trigger should have format like
          [
              {
                  name: {String},
                  params: {},
                  target: {String}'
              },
          ]
      * @returns {Array} of the same troggers with 'flows' keys inside
  */
  async getTriggerFlows() {
    let triggers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    const headers = await this.getHeaders();
    return _bluebird.default.try(() => _axios.default.post(`${this.sdkApiUrl}/event-manager/get-trigger-flows`, {
      triggers
    }, headers)).then(response => _bluebird.default.resolve(response.data));
  }
  async listVersions(_ref7) {
    let {
      flowId
    } = _ref7;
    return this._callApi({
      path: `/flow-versions`,
      queryParams: {
        flowId
      }
    });
  }
  async getVersion(_ref8) {
    let {
      flowId,
      version
    } = _ref8;
    return this._callApi({
      path: `/flow-versions/${version}`,
      queryParams: {
        flowId
      }
    });
  }
  async listFlowVersionsByBotId(_ref9) {
    let {
      botId
    } = _ref9;
    const binding = await this.getBinding();
    return binding.query.listFlowVersionsByBotId({
      botId
    });
  }
  async loadLogs(_ref10) {
    let {
      flowId,
      next,
      startTime,
      endTime,
      limit,
      filter,
      relativeTime
    } = _ref10;
    const headers = await this.getHeaders();
    const logsUrl = `${this.deployerUrl}/flows/${flowId}/logs`;
    const queryParams = {
      skipOriginal: true
    };
    if (next) {
      queryParams.next = next;
    }
    if (startTime) {
      queryParams.start = startTime;
    }
    if (endTime) {
      queryParams.end = endTime;
    }
    if (limit) {
      queryParams.limit = limit;
    }
    if (filter) {
      queryParams.filter = filter;
    }
    if (relativeTime) {
      queryParams.relativeTime = relativeTime;
    }
    return _bluebird.default.try(() => _axios.default.get(logsUrl, _lodash.default.merge({
      params: queryParams
    }, headers))).then(response => _bluebird.default.resolve(response.data)).then(responseJson => {
      if (_lodash.default.has(responseJson, 'errorMessage')) {
        throw responseJson;
      }
      return responseJson;
    });
  }
  async saveFlow(flow) {
    let {
      previousVersion
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    flow.id = flow.id || 'new';
    const res = await this._callApi({
      path: `/flows/${flow.id}`,
      payload: {
        flow,
        previousVersion
      },
      method: 'post',
      queryParams: {}
    });
    return this.setDiff(flow, res);
  }
  async getRemoteDataOutsByBotId(id) {
    const botFLows = await this.getFlowsByBotId(id, ['id', 'data.label', 'data.meta.sharedDataOuts', 'data.meta.dataOuts']);
    return _lodash.default.reduce(botFLows, (acc, flow) => {
      const flowLabel = _lodash.default.get(flow, 'data.label', 'No name flow');
      const dataOuts = _lodash.default.reject(_lodash.default.get(flow, 'data.meta.dataOuts'), dataOut => dataOut.type === 'session' || _lodash.default.isEmpty(dataOut.name) || _lodash.default.isEmpty(dataOut.type));
      acc[flow.id] = _lodash.default.map(dataOuts, dataOut => ({
        ...dataOut,
        botId: id,
        flowId: flow.id,
        flowLabel
      }));
      return acc;
    }, {});
  }
  async _pollResult(flowId, requestId, headers, progresCallback, options) {
    let counter = 0;
    const maxAttempts = _lodash.default.get(options, ['maxAttempts'], 100);
    const attemptDelay = _lodash.default.get(options, ['attemptDelay'], 3000);
    do {
      counter++;
      await _bluebird.default.delay(attemptDelay);
      const {
        data: result
      } = await _axios.default.get(`${this.checkUrl}/${flowId}/${requestId}`, headers).catch(e => {
        throw new Error((0, _utils.parseAxiosError)(e));
      });
      if (_lodash.default.isFunction(progresCallback)) {
        progresCallback(result);
      }
      if (result.status !== 'pending') {
        if (result.errorData) {
          throw result;
        }
        return result;
      }
      // queue is busy, wait 10s to release
      if (result?.status?.message === 'waitingForQueue') await _bluebird.default.delay(5000);
    } while (counter < maxAttempts);
    throw new Error('Activation duration is too long');
  }

  // unlockFlow ({id, lockId}) {
  //     return Promise.try(() => Vue.http.delete(`${this.flowsLockUrl}/${id}`, _.merge({params : {lockId}}, this.headers)))
  //         .then(response => response.json());
  // }

  static getEmptyStep(stepId) {
    return {
      id: stepId || (0, _uuid.v4)(),
      icon: 'add',
      iconType: 'default',
      iconUrl: '',
      shape: 'empty',
      type: 'empty',
      pinLabel: true,
      stepInputData: {}
    };
  }
  static getEmptyFlow(botId, userRole) {
    return {
      botId,
      data: {
        label: '',
        description: '',
        deploy: {
          memory: defaultLambdaMemorySize,
          timeout: defaultLambdaTimeout,
          role: userRole || 'USER'
        },
        meta: {},
        color: null,
        categories: null,
        annotations: [],
        stepTemplates: [],
        trees: {
          main: {
            position: {
              x: 0,
              y: 0
            },
            steps: [this.getEmptyStep()]
          }
        }
      }
    };
  }
  static async getNewFlow(botId, userRole, flowTemplate) {
    const flow = this.getEmptyFlow(botId, userRole);
    const template = _lodash.default.omit(flowTemplate, ['id', 'botId', 'dateCreated', 'dateModified', 'version']);

    // if template has any steps then remove default empty step
    // or leave it otherwise
    flow.data.steps = _lodash.default.get(template, 'data.steps.length') > 0 ? [] : flow.data.steps;

    // merge step with flow template
    return _lodash.default.merge(flow, template);
  }
}
var _default = FlowsApi;
exports.default = _default;